import { Component, OnInit, ViewChild } from '@angular/core';
import { MapsService } from 'src/app/Services/maps.service';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { from } from 'rxjs';



@Component({
  selector: 'app-map-admin',
  templateUrl: './map-admin.component.html',
  styleUrls: ['./map-admin.component.scss'],

})
export class MapAdminComponent implements OnInit {

  constructor(
    private mapService: MapsService,

  ) { }

  tipoUsuario = localStorage.getItem("type"); convenio = localStorage.getItem("convenio");

  public form = {
    infoPedido: [
      { direccion: null },
      { direccion: null },
      { direccion: null },
      { direccion: null },
      { direccion: null }
    ],
    precio_prev: 0,
    descuento: 0,
    porcentaje_descuento: 0,
    precio_descuento: 0,
    precio: null,
    precio_convenio: null,
    cod_desc: null,
    kilometros: null,

  }

  //ViewChild
  @ViewChild('map') map: any;
  @ViewChild('placesRef0') placesRef0: any;
  @ViewChild('placesRef1') placesRef1: any;
  @ViewChild('placesRef2') placesRef2: any;
  @ViewChild('placesRef3') placesRef3: any;
  @ViewChild('placesRef4') placesRef4: any;


  public options: any = {
    componentRestrictions: { country: 'co' },
    fields: ["place_id", "address_components", "name", "formatted_address", "geometry"],
    strictBounds: true,
  };



  directionsService = new google.maps.DirectionsService();
  directionsRenderer = new google.maps.DirectionsRenderer({
    suppressMarkers: true,
    polylineOptions: {
      strokeColor: "#ff0000",
      strokeOpacity: 1,
      strokeWeight: 3
    }
  });




  seleccionarDirecion(address: any, index: number): void {

    this.rellenarValoresDirecciones(index);
    this.buildingLocations(address, index);
    this.newPositionMap(address, null);
    this.calculateAndDisplayRoute(this.directionsService, this.directionsRenderer);

    if (index === 0 || index === 1) {
      if (this.locations[0] != undefined && this.locations[1] !== undefined) {
        this.add1 = true;
      }
    } else if (index === 2) {
      this.add2 = true;
    } else if (index === 3) {
      this.add3 = true;
    }

  }

  rellenarValoresDirecciones(index: number): void {
    switch (index) {
      case 0:
        this.form.infoPedido[0].direccion = this.placesRef0.nativeElement.value;
        break;
      case 1:
        this.form.infoPedido[1].direccion = this.placesRef1.nativeElement.value;
        break;
      case 2:
        this.form.infoPedido[2].direccion = this.placesRef2.nativeElement.value;
        break;
      case 3:
        this.form.infoPedido[3].direccion = this.placesRef3.nativeElement.value;
        break;
      case 4:
        this.form.infoPedido[4].direccion = this.placesRef4.nativeElement.value;
        break;
    }
  }


  locations: any = [];
  origin: any = [];
  destination: any = [];
  waypts: any = [];

  buildingLocations(address: any, index: number) {
    this.waypts = [];

    this.locations[index] = {
      "addrees": address.formatted_address,
      "latlng": { lat: address.geometry.location.lat(), lng: address.geometry.location.lng() },
      "icon": `assets/iconsMarkerMaps/${(index == 0 ? "marker1" : "marker2")}.png`,
      "indexMarker": index + 1,
      "setMarker": true,
      "kilometraje": 0
    };

    this.origin = this.locations[0]["latlng"];

    for (let i = 1; i < this.locations.length - 1; i++) {
      this.waypts[i - 1] = { location: this.locations[i]["latlng"], stopover: true }
    }

    this.destination = this.locations[this.locations.length - 1]["latlng"];

  }

  showGroup2(): void {
    if (this.consultBeforeNewRoute(this.form.infoPedido[0], this.form.infoPedido[1])) {
      this.mapService.alertForm();
    } else {
      this.add1 = false;
      this.group2 = true;
      this.delete2 = true;
    }
  }
  showGroup3(): void {
    if (this.consultBeforeNewRoute(this.form.infoPedido[2])) {
      this.mapService.alertForm();
    } else {
      this.add2 = false; this.group3 = true; this.delete2 = false; this.delete3 = true;
    }
  }
  showGroup4(): void {
    if (this.consultBeforeNewRoute(this.form.infoPedido[3])) {
      this.mapService.alertForm();
    } else {
      this.add3 = false; this.group4 = true; this.delete3 = false; this.delete4 = true;
    }
  }

  consultBeforeNewRoute(datos1, datos2 = null) {
    let count1 = 0;
    let count2 = 0;
    for (let prop in datos1) {
      if (datos1[prop] === null || datos1[prop] === "") {
        count1++;
      }
    }
    if (datos2 != null) {
      for (let prop in datos2) {
        if (datos2[prop] === null || datos2[prop] === "") {
          count2++;
        }
      }
    }
    return (count1 + count2) !== 0 ? true : false;
  }


  hideGroup(indexGroup): void {
    this.form.infoPedido[indexGroup] = { direccion: null};

    if (indexGroup == 2) {
      this.add1 = true; this.group2 = false; this.delete2 = true;
    } else if (indexGroup == 3) {
      this.add2 = true; this.group3 = false; this.delete2 = true; this.delete3 = false;
    } else if (indexGroup == 4) {
      this.add3 = true; this.group4 = false; this.delete3 = true; this.delete4 = false;
    }



    if (this.locations[indexGroup] !== undefined) {
      this.locations.pop();
    }

    this.waypts = [];
    this.destination = this.locations[this.locations.length - 1]["latlng"];

    for (let i = 1; i < this.locations.length - 1; i++) {
      this.waypts[i - 1] = { location: this.locations[i]["latlng"], stopover: true }
    }

    this.newPositionMap(null, this.destination)
    this.calculateAndDisplayRoute(this.directionsService, this.directionsRenderer);
  }

  group2: boolean = false; group3: boolean = false; group4: boolean = false;

  add1: boolean = false; add2: boolean = false; add3: boolean = false;
  delete2: boolean = false; delete3: boolean = false; delete4: boolean = false;


  newPositionMap(address: Address, choordsDestine: any): void {
    let choords = choordsDestine == null ? { lat: address.geometry.location.lat(), lng: address.geometry.location.lng() } : choordsDestine;

    let mapa = new google.maps.Map(this.map.nativeElement, {
      zoom: 14,
      center: choords,
      disableDefaultUI: true
    });
    this.directionsRenderer.setMap(mapa);
    this.setMarkers(mapa);

  }
  setMarkers(map: google.maps.Map): void {
    for (let i = 0; i < this.locations.length; i++) {
      const { addrees, latlng, icon, indexMarker, setMarker } = this.locations[i];
      new google.maps.Marker({
        position: latlng,
        map,
        icon: (setMarker == true) ? icon : null,
        title: addrees,
        zIndex: indexMarker,
        animation: google.maps.Animation.DROP,
        draggable: false,
      });
    }
  }

  public oficinaARecojo: any = 0;
  calculateOficinaARecojo(directionsService: any): Promise<number> {

    return new Promise<number>((resolve) => {
      directionsService
        .route({
          origin: this.mapService.direccionOficina,
          destination: this.locations[0]["latlng"],
          travelMode: google.maps.TravelMode.DRIVING,
        })
        .then((response) => resolve(response))
        .catch((e) => console.log("Directions request failed due to " + e));
    })

  }

  finalPrice: any;

  calculateAndDisplayRoute(directionsService: any, directionsRenderer: any): void {

    from(this.calculateOficinaARecojo(this.directionsService)).subscribe(result => this.oficinaARecojo = result)

    if (this.locations[0] != undefined && this.locations[1] !== undefined) {

      directionsService
        .route({
          origin: this.origin,
          destination: this.destination,
          optimizeWaypoints: false,
          waypoints: this.waypts,
          travelMode: google.maps.TravelMode.DRIVING,
          unitSystem: google.maps.UnitSystem.METRIC
        })
        .then((response) => {

          directionsRenderer.setDirections(response);
          let routes = response.routes[0].legs;
          this.finalPrice = this.mapService.calculatePrize(this.oficinaARecojo, routes); 
          this.obtenerPrecios(this.finalPrice);

           
        })
        .catch((e) => console.log("Directions request failed due to " + e));
    }
  }
  precioNoCharge:number = 0;
  precioCharge:number = 0;

  obtenerPrecios(finalPrice: any): void 
  {

      this.precioNoCharge =  Number(finalPrice["precioBase"]) + Number(finalPrice["precioDistanciaRecorrida"]);
      this.precioCharge =  Number(finalPrice["precioBase"])+ Number(finalPrice["precioDistanciaRecorrida"]) + Number(finalPrice["precioCargoNocturno"]);
   

  }


  



  ngOnInit() {

    this.mapService.preciosPedido();
    new google.maps.Map(this.map.nativeElement, { zoom: 13, center: this.mapService.getChoords, disableDefaultUI: true, });
    const direcciones = [this.placesRef0, this.placesRef1, this.placesRef2, this.placesRef3, this.placesRef4];

    direcciones.forEach((el, index) => {

      const direccion = el.nativeElement;
      const autocompletado = new google.maps.places.Autocomplete(direccion, this.options);
      google.maps.event.addListener(autocompletado, 'place_changed', () => {
        this.form.infoPedido[index].direccion = direccion.value;
      })

    })

  }


 


  onSubmit(): void {
  }




}
